import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-082c20d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "performance-chart" }
const _hoisted_2 = { class: "chart-header" }
const _hoisted_3 = { class: "header-left" }
const _hoisted_4 = { class: "title-row" }
const _hoisted_5 = {
  key: 0,
  class: "metrics-inline"
}
const _hoisted_6 = { class: "metric-item" }
const _hoisted_7 = { class: "metric-label" }
const _hoisted_8 = { class: "metric-item" }
const _hoisted_9 = { class: "metric-label" }
const _hoisted_10 = { class: "metric-item" }
const _hoisted_11 = { class: "metric-label" }
const _hoisted_12 = { class: "time-range-selector" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  key: 0,
  ref: "chartRef",
  class: "chart-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Nodata = _resolveComponent("Nodata")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.t('performanceChart.title')), 1),
          (_ctx.hasMetrics)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.t('performanceChart.annualizedReturn')) + "：", 1),
                  _createElementVNode("span", {
                    class: "metric-value",
                    style: _normalizeStyle({ color: _ctx.annualizedColor })
                  }, _toDisplayString(_ctx.formattedAnnualized), 5)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.t('performanceChart.totalReturn')) + "：", 1),
                  _createElementVNode("span", {
                    class: "metric-value",
                    style: _normalizeStyle({ color: _ctx.totalColor })
                  }, _toDisplayString(_ctx.formattedTotal), 5)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.t('performanceChart.totalDividendYield')) + "：", 1),
                  _createElementVNode("span", {
                    class: "metric-value",
                    style: _normalizeStyle({ color: _ctx.dividendColor })
                  }, _toDisplayString(_ctx.formattedDividend), 5)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_12, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timeRanges, (range) => {
            return (_openBlock(), _createElementBlock("button", {
              key: range.value,
              class: _normalizeClass(['range-btn', { active: _ctx.selectedRange === range.value }]),
              onClick: ($event: any) => (_ctx.handleRangeChange(range.value))
            }, _toDisplayString(range.label), 11, _hoisted_13))
          }), 128))
        ])
      ])
    ]),
    (_ctx.data && _ctx.data.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, null, 512))
      : (_openBlock(), _createBlock(_component_Nodata, {
          key: 1,
          mode: "vertical",
          customdesc: _ctx.t('performanceChart.noData')
        }, null, 8, ["customdesc"]))
  ]))
}